import { Box } from '@mui/material';
import React from 'react';
import CAppFilterSelect from '../../../../../../../app/components/CAppFilterSelect';
import IInvestExpertiseFilters from '../../../../../interfaces/expertise/IInvestExpertiseFilters';
import { useTranslation } from 'react-i18next';
import CAppInfoTooltip from '../../../../../../../app/components/CAppInfoTooltip';
import investmentFundLang from '../../../../../langs/investmentFundLang';
import IInvestor from '../../../../../interfaces/IInvestor';
import investmentFilterLang from '../../../langs/investmentFilterLang';

type CFiltersInvestorSelectProps = {
	optionsInvestors: IInvestor[];
	filters: IInvestExpertiseFilters;
	onChange: (filters: IInvestExpertiseFilters) => void;
};

const CFiltersInvestorSelect = (props: CFiltersInvestorSelectProps) => {
	const { optionsInvestors, filters, onChange } = props;

	const { t } = useTranslation();

	return (
		<CAppFilterSelect
			className="filter-investor"
			multiple
			multipleRenderTags={(val: IInvestor[]) => (
				<Box style={{ paddingLeft: '5px', fontSize: '0.85rem' }}>
					{t(investmentFundLang.x_sub_portfolios.tag, { count: val ? val.length : 0 })}
				</Box>
			)}
			label={
				<>
					{t(investmentFilterLang.sub_portfolio.tag)}
					<CAppInfoTooltip title={t(investmentFundLang.label_all_sub_portfolios_tooltip.tag)} />
				</>
			}
			value={
				optionsInvestors
					? optionsInvestors.filter(
							(x) => filters && filters.investorIds && filters.investorIds.includes(x.id),
					  ).length === 0
						? optionsInvestors
						: optionsInvestors.filter(
								(x) => filters && filters.investorIds && filters.investorIds.includes(x.id),
						  )
					: null
			}
			onChange={(val: IInvestor[]) =>
				onChange({
					...filters,
					investorIds: val && val.length > 0 ? val.map((x) => x.id) : null,
				})
			}
			size="small"
			options={optionsInvestors}
		/>
	);
};

export default CFiltersInvestorSelect;
